import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import RentalCalendar from "../../../components/Calendar/RentalCalendar";
import UpcomingPickups from "../../../components/Calendar/UpcomingPickups";
import VehicleUtilization from "../../../components/Calendar/VehicleUtilization";
import UpcomingReturns from "../../../components/Calendar/UpcomingReturns";
import CombinedRentalHandoverModal from "../../../components/RentalModal/CombinedRentalHandoverModal";

function Availability({rentalsData, isLoading, fetchRentalsForDateRange}) {
  const [isHandoverModalOpen, setIsHandoverModalOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);

  const handleDateClick = (date) => {
    setSelectedDate(date);
    setIsHandoverModalOpen(true);
  };

  const handleModalClose = () => {
    setIsHandoverModalOpen(false);
    setSelectedDate(null);
  };

  const handleModalSuccess = () => {
    setIsHandoverModalOpen(false);
    setSelectedDate(null);
    // Optionally refresh rentals data here
  };  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
      className="space-y-6"
    >
      {/* Loading indicator */}
      {isLoading && (
        <div className="flex items-center justify-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          <span className="ml-3 text-gray-600">Loading rental calendar...</span>
        </div>
      )}

      {/* Calendar Overview Section */}
      <div className="bg-white rounded-lg shadow-md overflow-hidden">
        <div className="p-6">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            Vehicle Availability Calendar
          </h2>          <p className="text-gray-600 mb-6">
            Track all rentals, pickups, and returns with our interactive
            calendar view. Click on any date to create a new rental.
          </p>{/* Calendar Component */}          <RentalCalendar 
            rentals={rentalsData} 
            onDateClick={handleDateClick}
            fetchRentalsForDateRange={fetchRentalsForDateRange}
          />
        </div>
      </div>

      {/* Stats Dashboard */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0.1 }}
          className="bg-white rounded-lg shadow-md p-6"
        >
          <h3 className="text-lg font-semibold text-gray-800 mb-4">
            Upcoming Pickups
          </h3>
          <UpcomingPickups rentals={rentalsData} />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0.2 }}
          className="bg-white rounded-lg shadow-md p-6"
        >
          <h3 className="text-lg font-semibold text-gray-800 mb-4">
            Upcoming Returns
          </h3>
          <UpcomingReturns rentals={rentalsData} />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0.3 }}
          className="bg-white rounded-lg shadow-md p-6"
        >
          <h3 className="text-lg font-semibold text-gray-800 mb-4">
            Vehicle Utilization
          </h3>
          <VehicleUtilization rentals={rentalsData} />
        </motion.div>
      </div>

      {/* Combined Rental Handover Modal */}
      <CombinedRentalHandoverModal 
        isOpen={isHandoverModalOpen}
        onClose={handleModalClose}
        onSuccess={handleModalSuccess}
        selectedDate={selectedDate}
      />
    </motion.div>
  );
}

export default Availability;
